import { modalCreate, showCardCreate } from '@subaio/components'

import { ModalShadow } from './ModalShadow'

export const { ModalProvider, useModal } = modalCreate({
	types: {
		showCard: showCardCreate(({ theme }) => ({
			backgroundColor: theme.color.background,
			textColor: theme.color.text,
			showShadow: true,
		})),
	},
	renderShadow: {
		content: (key, props) => <ModalShadow key={key} {...props} />,
		duration: 0,
	},
})
